export default __webpack_public_path__ + "static/media/poisson.c46f4e2a.jpg";